// extracted by mini-css-extract-plugin
export default {"container":"TZktI3","text":"c1U5uy","buttonContainer":"ampNBR","retryButton":"XnIpTw"};